import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";

import AdminContainer from "../AdminContainer/AdminContainer";
import CourierContainer from "../CourierContainer/CourierContainer";
import CustomerContainer from "../CustomerContainer/CustomerContainer";
import PublicContainer from "../PublicContainer/PublicContainer";
import AuthContainer from "../AuthContainer/AuthContainer";
import NotFoundPage from "./../../pages/Page/NotFoundPage/NotFoundPage";
import PreLoader from "../../helpers/PreLoader/PreLoader";
import { decodeJWT, getCookies } from "../../utils";
import { setUserAction } from "../../redux/actions/userActions/userActions";
import {
  clearAuthAction,
  setAuthAction,
} from "../../redux/actions/authActions/authActions";
import { setSocketActions } from "./../../redux/actions/socketActions/socketActions";

const App = () => {
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  const loader = useSelector((state) => state.loader);

  const accessToken = getCookies("accessToken");

  useEffect(() => {
    if (accessToken) {
      const decodedToken = decodeJWT(accessToken);
      const dateNow = Date.now() / 1000;
      if (decodedToken?.exp < dateNow) dispatch(clearAuthAction());
      else {
        dispatch(setAuthAction(accessToken));
      }
    }
  });

  useEffect(() => {
    if (accessToken) {
      // Connect with Socket IO
      dispatch(setSocketActions(accessToken));
      // Get User Profiles
      dispatch(setUserAction());
    }
  }, [accessToken]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  const theme = localStorage.getItem("theme");

  return (
    <>
      {loader && <PreLoader />}

      {/* RHT */}
      <Toaster
        toastOptions={{
          position: "top-left",
          style: theme === "dark" ? { background: "#333", color: "#fff" } : {},
        }}
      />
      {/* React Toastify */}
      <ToastContainer position="bottom-left" rtl />

      <Routes>
        {/* Admin Container */}
        <Route path="/admin/*" element={<AdminContainer />} />
        {/* Courier Container */}
        <Route path="/courier/*" element={<CourierContainer />} />
        {/* Customer Container */}
        <Route path="/customer/*" element={<CustomerContainer />} />
        {/* Auth Container */}
        <Route path="/auth/*" element={<AuthContainer />} />
        {/* Public Container */}
        <Route path="/*" element={<PublicContainer />} />
        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default App;
